<template>
	<div class="coun_deta">
		<div class="council_deta">
			<div class="crumbs">当前位置：论坛首页-论坛理事会-专家文章</div>
			<div class="deta_list">
				<div class="personal">
					<div class="interval">
						<div class="title">
							<div class="photo">
								<img :src="wenzhang.avator" alt="">
							</div>
							<div class="info">
								<div class="name">{{wenzhang.name}}</div>
								<div class="text">{{wenzhang.title}}</div>
							</div>
						</div>
						<div class="referral">
							<div class="refe_list">
								<div class="intro"><img src="../../assets/wbanner_53.png" alt="">背景</div>
								<div class="word">{{wenzhang.background}}</div>
							</div>
						
						</div>
					</div>
				</div>
				<div class="essay_bg">
					<div class="essay">
						<div class="title">他的文章</div>
						<div class="essay_list">
							
							<div class="esslist">
								<div class="list" v-for="(item,index) in sec1">
									<router-link style="color: #666666;text-decoration: none;" :to="{path:'/council_figure',query:{id:item.id,c:item.createTime,u:item.expertsTime,exp:item.expertID}}">
									<div class="name">{{item.title}}</div>
								
									<div class="more">
										<div class="time">{{item.createTime}}</div>
										<div class="arrows_right"><img src="../../assets/wbanner_54.png" alt=""></div>
									</div>
									</router-link>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<el-pagination
		  background
		  layout="prev, pager, next"
		  :total="total"
		  :page-size="tablePage.pageSize"
		  :current-page="tablePage.pageNum"
		  @size-change="handleSizeChange"
		  @current-change="handlePageChange"
		  >
		</el-pagination>
	</div>
</template>

<script>
	import { encrypt,decrypt, generatekey } from "@/plugins/des2.js"
	import qs from 'qs'
	import {ExpertDetail,ArticleExpertList,ExpertAllList} from '../../api/api.js'
	export default {
		name: 'council_details',
		data() {
			return {
				wenzhang:[],
				text_id:'',
				exp_id:'',
				text_createTime:'',
				text_undateTime:'',
				cont:[],
				list: [],
				sec1:[],
				zhuanjia:[],
				tablePage: {
					pageNum: 1, // 第几页
					pageSize: 20, // 每页多少条
				},
				total:1
			}
		},
		mounted() {
			
			this.text_id=this.$route.query.id
			this.updateTime=this.$route.query.u.substr(0,10)
				this.exp_id=this.$route.query.exp_id
			this.ExpertDetail()
			this.ArticleExpertList()
			this.ExpertAllList()
			// console.log(this.text_id)
			// console.log(this.updateTime)
		},
		methods:{
			handlePageChange(currentPage) {
			  this.tablePage.pageNum = currentPage
			  this.ArticleExpertList()
			  // 在此刷新数据
			},
			handleSizeChange(pageSize) {
				console.log(pageSize)
			  this.tablePage.pageSize = pageSize
			  // 在此刷新数据
			},
			//获取某专家的文章
			async ArticleExpertList(){
				//加密
				const key = localStorage.getItem('key')// generatekey(8); // 也可直接指定固定key值 let key = 'des';  
				let time = parseInt(new Date().getTime() / 1000)
				let data={
				      	token: time+"&"+localStorage.getItem('token'),
				      	os: "Web",
				      	expertID:this.exp_id,
						page:this.tablePage.pageNum
				}
				      //如果是对象/数组的话，需要先JSON.stringify转换成字符串
				const encrypts = encrypt(JSON.stringify(data), key, key);
				let encrypts1 = encrypts.replace(/\//g,"@@");
				let encrypts2 = encrypts1.replace(/[+]/g,"$$$$");
				let requetp={
						p:encrypts2
				}	
				let res=await ArticleExpertList(qs.stringify(requetp))
				//解密
				let res1=res.data
				let encrypts3 = res1.replace(/@@/g, "/");
				let encrypts4 = encrypts3.replace(/\$\$/g, "+");
				const dess = decrypt(encrypts4,key,key);  
				let sec1a=JSON.parse(dess).d.Data
				this.total=JSON.parse(dess).d.Total
				sec1a.forEach((e)=>{
					e.createTime=e.createTime.substr(0,10)
				})
				this.sec1=sec1a
				// this.zj=this.wenzhang.expertInfo
				// console.log(this.wenzhang)
			
			},
			//文章详情
			async ExpertDetail(){
				//加密
				const key = localStorage.getItem('key')// generatekey(8); // 也可直接指定固定key值 let key = 'des';  
				let time = parseInt(new Date().getTime() / 1000)
				let data={
				      	token: time+"&"+localStorage.getItem('token'),
				      	os: "Web",
				      	expertIDs:[{expertID:this.text_id,updateTime:this.updateTime}]
				}
				      //如果是对象/数组的话，需要先JSON.stringify转换成字符串
				const encrypts = encrypt(JSON.stringify(data), key, key);
				let encrypts1 = encrypts.replace(/\//g,"@@");
				let encrypts2 = encrypts1.replace(/[+]/g,"$$$$");
				let requetp={
						p:encrypts2
				}	
				let res=await ExpertDetail(qs.stringify(requetp))
				//解密
				let res1=res.data
				let encrypts3 = res1.replace(/@@/g, "/");
				let encrypts4 = encrypts3.replace(/\$\$/g, "+");
				const dess = decrypt(encrypts4,key,key);  
				this.wenzhang=JSON.parse(dess).d[0]
				console.log(this.wenzhang)
				
			}
		}
	}
</script>

<style scoped>
	.coun_deta .council_deta {
		background-color: #fafafa;
		padding-bottom: 15px;
	}

	.coun_deta .crumbs {
		width: 1200px;
		margin: 0 auto;
		padding-top: 30px;
		font-size: 16px;
		color: #999999;
	}

	.coun_deta .deta_list {
		display: flex;
		justify-content: space-between;
		flex-wrap: wrap;
		width: 1200px;
		margin: 0 auto;
		margin-top: 20px;
	}

	.coun_deta .deta_list .personal {
		background-color: #fff;
		border-radius: 10px;
		width: 34%;
		height: 100%;
	}

	.coun_deta .deta_list .personal .interval {
		padding: 28px 28px 0 28px;
	}

	.coun_deta .deta_list .personal .title {
		display: flex;
		justify-content: space-between;
		flex-wrap: wrap;
	}

	.coun_deta .deta_list .personal .title .photo {
		width: 20%;
		height: 20%;
		margin-right: 15px;
	}

	.coun_deta .deta_list .personal .title .photo img {
		width: 70px;
		height: 70px;
	}

	.coun_deta .deta_list .personal .title .info {
		width: 73%;
	}

	.coun_deta .deta_list .personal .title .info .name {
		font-size: 24px;
		color: #333;
		margin-bottom: 3px;
	}

	.coun_deta .deta_list .personal .title .info .text {
		font-size: 18px;
		color: #666666;
	}

	.coun_deta .deta_list .personal .referral {
		margin-top: 35px;
	}

	.coun_deta .deta_list .personal .referral .refe_list {
		margin-bottom: 38px;
	}

	.coun_deta .deta_list .personal .referral .intro {
		font-size: 18px;
		color: #333;
		margin-bottom: 5px;
		font-weight: bold;
	}

	.coun_deta .deta_list .personal .referral .intro img {
		vertical-align: middle;
		margin: -3px 10px 0 0;
	}

	.coun_deta .deta_list .personal .referral .word {
		font-size: 15px;
		color: #333;
		line-height: 30px;
	}

	.coun_deta .deta_list .essay_bg {
		background-color: #fff;
		border-radius: 10px;
		width: 63%;
	}

	.coun_deta .deta_list .essay_bg .essay {
		padding: 25px 28px;
	}

	.coun_deta .deta_list .essay_bg .essay .title {
		font-size: 18px;
		color: #333;
		margin-bottom: 30px;
	}
	.coun_deta .deta_list .essay_bg .essay .essay_list .esslist{
		text-decoration: none;
	}
	.coun_deta .deta_list .essay_bg .essay .essay_list .list {
		border-bottom: 1px solid #eeeeee;
		padding-bottom: 15px;
		margin-bottom: 26px;
	}

	.coun_deta .deta_list .essay_bg .essay .essay_list .name {
		font-size: 18px;
		color: #333;
		margin-bottom: 10px;
		font-weight: bold;
	}

	.coun_deta .deta_list .essay_bg .essay .essay_list .text {
		font-size: 16px;
		color: #333;
		line-height: 25px;
		margin-bottom: 10px;
	}

	.coun_deta .deta_list .essay_bg .essay .essay_list .more {
		display: flex;
		justify-content: space-between;
		flex-wrap: wrap;
	}

	.coun_deta .deta_list .essay_bg .essay .essay_list .more .time {
		font-size: 14px;
		color: #999999;
	}
	@media screen and (max-width: 1400px){
		.coun_deta .crumbs {
		    width: 900px;
		    padding-top: 20px;
		    font-size: 16px;
		}
		.coun_deta .deta_list {
		    width: 900px;
		    margin-top: 20px;
		}
	}
	@media screen and (max-width: 1000px){
		.coun_deta .crumbs {
		    width: 750px;
		    margin-top: 10px;
		    font-size: 16px;
		}
		.coun_deta .deta_list {
		    width: 750px;
		    margin-top: 10px;
		}
		.coun_deta .deta_list .personal {
		    width: 100%;
		    height: 100%;
			margin-bottom: 10px;
		}
	
		.coun_deta .deta_list .personal .title .info {
		    width: 76%;
		}
		.coun_deta .deta_list .personal .title {
		    display: flex;
		    justify-content: space-between;
		    flex-wrap: wrap;
		    align-items: center;
		}
	}
	@media screen and (max-width: 768px){
		.coun_deta{
			margin-top: 60px;
		}
		.coun_deta .crumbs {
		    width: 98%;
		    margin-top: 0px;
		    font-size: 14px;
		}
		.coun_deta .deta_list .personal .title .info .name {
		    font-size: 18px;
		    color: #333;
		    margin-bottom: 3px;
		}
		.coun_deta .deta_list .personal .title .info .text {
		    font-size: 14px;
		    color: #666666;
		}
		.coun_deta .deta_list .personal .referral {
		    margin-top: 10px;
		}
		.coun_deta .deta_list .personal .referral .intro {
		    font-size: 16px;
		    color: #333;
		    margin-bottom: 5px;
		    font-weight: bold;
		}
		.coun_deta .deta_list .personal .referral .word {
		    font-size: 14px;
		    color: #333;
		    line-height: 30px;
		}
		.coun_deta .deta_list .personal .referral .refe_list {
		    margin-bottom: 10px;
		}
		.coun_deta .deta_list .personal .interval {
		    padding: 10px;
		}
		.coun_deta .deta_list .essay_bg .essay {
		    padding: 10px;
		}
		.coun_deta .deta_list .essay_bg .essay .title {
		    font-size: 18px;
		    color: #333;
		    margin-bottom: 10px;
		}
		.coun_deta .deta_list .essay_bg .essay .essay_list .name {
		    font-size: 16px;
		    color: #333;
		    margin-bottom: 5px;
		    font-weight: bold;
		}
		.coun_deta .deta_list .essay_bg .essay .essay_list .text {
		    font-size: 14px;
		    color: #333;
		    line-height: 25px;
		    margin-bottom: 5px;
		}
		.coun_deta .deta_list .essay_bg .essay .essay_list .esslist img{
			zoom: 0.7;
		}
		.coun_deta .deta_list {
		    width: 98%;
		    margin-top: 10px;
		}
	}
	@media screen and (max-width: 568px){
		.coun_deta .deta_list .personal .title .info {
		    width: 73%;
		}
	}
	
	.coun_deta .deta_list .essay_bg {	
		width: 63% !important;
	}
	@media screen and (max-width: 768px){
		.coun_deta .deta_list .essay_bg {
			
			width: 100% !important;
		}
	}
	.coun_deta .deta_list .essay_bg .essay .essay_list .text{
		text-indent:0% !important
	}
</style>